import type { ComponentProps, ReactNode } from 'react'
import { FileCheck, Loader } from 'lucide-react'
import { Button } from '~/components/ui/button'

type AttendanceButtonProps = Omit<ComponentProps<typeof Button>, 'onClick' | 'disabled' | 'children'> & {
  onClick: () => void
  loading: boolean
  children: ReactNode
}

/**
 * Bouton de téléchargement d'un relevé d'assiduité (#322), sur la fiche
 * apprenant comme sur celle du parcours : même icône, même attente.
 */
function AttendanceButton({ onClick, loading, children, variant = 'outline', ...props }: AttendanceButtonProps) {
  return (
    <Button variant={variant} onClick={onClick} disabled={loading} aria-busy={loading} {...props}>
      {loading ? <Loader className="mr-2 size-4 animate-spin" aria-hidden="true" /> : <FileCheck className="mr-2 size-4" aria-hidden="true" />}
      {children}
    </Button>
  )
}

export default AttendanceButton
